import DiscoWidgetMarketingCard from './DiscoWidgetMarketingCard';

export default DiscoWidgetMarketingCard;
